import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import PostActions from 'components/FeedList/Post/PostActions';
import ProfileIcon from 'components/ProfileIcon';
import TimeSince from 'components/TimeSince';
import { fromIso9075DateString } from 'utils/dates';
import { userShape, wallPostShape } from 'utils/shapes';
import PurpleWIcon from 'resources/PurpleW.png';
import WheelWinsImg from './WheelWinsIcon.png';
import './WheelWins.css';

class WheelWins extends PureComponent {
  render() {
    const { post, user, onDeletePost } = this.props;
    const json = JSON.parse(post.message);

    return (
      <div className="feed-wheelwins">
        <div className="feed-message-specifics">
          <ProfileIcon src={PurpleWIcon} size={50} withBorder />
          <div className="feed-message-author-container">
            <strong>Wheel Wins Awarded!</strong>
            <div className="post-time">
              <TimeSince
                date={fromIso9075DateString(post.created)}
                prefix="posted"
              />
            </div>
          </div>
        </div>

        <div className="wheelwins-image-and-body">
          <img className="wheelwins-image" src={WheelWinsImg} alt="" />
          <div className="message-body">
            {json.hasOwnProperty('winnerDisplayName') && (
              <div className="winner-message">
                Congratulations{' '}
                <span className="winner-name">{json.winnerDisplayName}!</span>{' '}
                has been awarded <strong>1 Wheel Wins Spin!</strong>
              </div>
            )}
            <div className="winner-message-text">
              Spin the Wheel Wins Wheel at your favourite Wind Creek Casino to
              win fabulous prizes.
            </div>
          </div>
        </div>
        <PostActions post={post} user={user} onDeletePost={onDeletePost} />
      </div>
    );
  }
}

WheelWins.propTypes = {
  user: userShape,
  post: wallPostShape,
  onDeletePost: PropTypes.func
};

export default WheelWins;
